import React from 'react';
import CheckInsReport from '../components/goal_cycle/CheckInsReport';
import ThemeWrapper from '../components/styles/ThemeWrapper/index.js';
import ErrorBoundary from '../components/errors/ErrorBoundary';
import Flexbox from 'flexbox-react';
import { Provider } from 'mobx-react';

export default class CheckInsReportView extends React.Component {
  render() {
    return (
      <Provider>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox
              flexGrow={1}
              width="100hw"
              alignContent="stretch"
              flexDirection="column"
              paddingBottom="0px"
            >
              <Flexbox
                flexGrow={1}
                flexDirection="column"
                className="fixed-width-container"
                marginTop="20px"
              >
                <CheckInsReport />
              </Flexbox>
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}
